import { useRef, useState } from 'react';

export const useFamilyByOptionInfoTooltip = () => {
    const [showInfoTooltip, setShowInfoTooltip] = useState<boolean>(false);
    const infoTooltipRef = useRef<HTMLDivElement | null>(null);

    return { setShowInfoTooltip, infoTooltipRef, showInfoTooltip };
};
